<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XvqTdG/tc-custom/9780226925363.jpg?1732158839277" alt="This image is the cover for the book Ignoring Nature No More"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ignoring Nature No More
      </h1>
      <p class="bookDescription body article font2">
        <p>For far too long humans have been ignoring nature. As the most dominant, overproducing, overconsuming, big-brained, big-footed, arrogant, and invasive species ever known, we are wrecking the planet at an unprecedented rate. And while science is important to our understanding of the impact we have on our environment, it alone does not hold the answers to the current crisis, nor does it get people to act. In <i>Ignoring Nature No More</i>, Marc Bekoff and a host of renowned contributors argue that we need a new mind-set about nature, one that centers on empathy, compassion, and being proactive.           <br/> This collection of diverse essays is the first book devoted to compassionate conservation, a growing global movement that translates discussions and concerns about the well-being of individuals, species, populations, and ecosystems into action. Written by leading scholars in a host of disciplines, including biology, psychology, sociology, social work, economics, political science, and philosophy, as well as by locals doing fieldwork in their own countries, the essays combine the most creative aspects of the current science of animal conservation with analyses of important psychological and sociocultural issues that encourage or vex stewardship. The contributors tackle topics including the costs and benefits of conservation, behavioral biology, media coverage of animal welfare, conservation psychology, and scales of conservation from the local to the global. Taken together, the essays make a strong case for why we must replace our habits of domination and exploitation with compassionate conservation if we are to make the world a better place for nonhuman and human animals alike.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marc Bekoff
      </h2>
      
      <p class="authorDescription body article"><B>Marc Bekoff</B> is professor emeritus of ecology and evolutionary biology at the University of Colorado Boulder. His numerous books include <I>The Emotional Lives of Animals</I>, <I>The Animal Manifesto</I>, and <I>Wild Justice: The Moral Lives of Animals</I>, the last also published by the University of Chicago Press.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41d13622